import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/community-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Community: How To Join And Why It Matters</title>
        <meta
          name='description'
          content='Beyond selling your pre-loved items, being on Poshmark dispenses several other advantages. Your initial goal may be about making a profit, but registering an account already integrates you to the buyer and seller community, also known as Poshers. With a vibrant community of over 80 million people across the US, Canada, Australia, and India, everyone is welcome to join the social marketplace.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/community-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/community-poshmark' />
        <meta property='og:title' content='Poshmark Community: How To Join And Why It Matters' />
        <meta
          property='og:description'
          content='Beyond selling your pre-loved items, being on Poshmark dispenses several other advantages. Your initial goal may be about making a profit, but registering an account already integrates you to the buyer and seller community, also known as Poshers. With a vibrant community of over 80 million people across the US, Canada, Australia, and India, everyone is welcome to join the social marketplace.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
